<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <div class="col d-column">
      <h1 class="title pt-2 mb-0">Tags</h1>
      <h1 class="title">
        <span class="pb-2">
          {{ $ml.get("tagsAreUsedToHelpIdentifyReports") }}
        </span>
      </h1>

      <div class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light">{{ $ml.get("registerBelowTheTags") }}</h6>
        </div>
        <div class="card-body p-0">
          <div class="m-3">
            <div class="form-group">
              <div class="d-flex justify-content-between" style="gap: 5px;">
                <div class="col">
                  <input
                    type="text"
                    class="form-control"
                    v-model="tag"
                    maxlength="25"
                    placeholder="Insira o nome da tag"
                    @keyup.enter="alterTag"
                  />
                </div>
                <div class="col-24 col-md-6 d-flex justify-content-end">
                  <button class="btn btnForm ml-4" @click="alterTag">
                    <Spinner v-show="loadingBtn" />
                    <span v-show="!loadingBtn" v-text="$ml.get('add')"></span>
                  </button>
                </div>
              </div>
            </div>
            <hr />
            <div
              class="w-100 flex d-flex"
              style="flex-flow: row wrap; flex-basis: fit-content"
            >
              <b-row
                v-for="(tag, index) in optionsTags"
                :key="index"
                class="mr-2 mb-2"
                style="width: fit-content"
              >
                <b-col class="tagsListReport">
                  <span style="font-size: 0.7rem; white-space: nowrap">{{
                    tag[0].toUpperCase() + tag.slice(1)
                  }}</span>
                  <span class="tag-remove" @click="removeTags(tag)">x</span>
                </b-col>
              </b-row>
            </div>
            <!-- <b-form-tags
            class="inputTags mt-3 py-3"
            input-id="tags-pills"
            v-model="optionsTags"
            tag-variant="primary"
            tag-pills
            size="md"
            separator=","
            :placeholder="$ml.get('enterNewTags')"
            addButtonText=""
            variant="primary"
            :limit="30"
            :limit-tags-text="$ml.get('itIsNotPossibleToEnterMore')"
            ></b-form-tags>  -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyService from "../../services/company.service";
import Swal from "sweetalert2";
import { utils } from "../../utils";

const regexOTN = utils.regexCheck("OTN");

export default {
  data() {
    return {
      tag: "",
      optionsTags: [],
      loadingBtn: false,
    };
  },
  mounted() {
    this.changeTags();
  },
  methods: {
    removeTags(tag) {
      this.optionsTags = this.optionsTags.filter(
        (t) => t.toUpperCase() != tag.toUpperCase()
      );
      this.alterTag("remove");
    },
    changeTags() {
      this.optionsTags = [];
      CompanyService.getTags().then(
        (response) => {
          this.loadingBtn = false;
          this.optionsTags = response.data?.settings?.report_tags;
        },
        () => {
          this.loading = false;
        }
      );
    },

    alterTag(action) {

      if(!this.tag.trim() && action != 'remove') return;
      
      let verifyregex = false;
      var self = this;
      if (this.tag) {
        this.optionsTags = [...this.optionsTags, this.tag];
        this.tag = "";
      }
      this.optionsTags.forEach((element) => {
        if (!regexOTN(element)) {
          verifyregex = true;
        }
      });

      if (verifyregex) {
        Swal.fire({
          icon: "info",
          html: `<h4>${self.$ml.get("cannotEnterSpecialCharacters")}</h4`,
          showConfirmButton: false,
          timer: 10000,
        });
        return;
      }

      this.loadingBtn = true;
      CompanyService.putTags({
        tags: this.optionsTags?.map((tag) => tag),
      })
        .then(() => {
          this.changeTags();
          this.loadingBtn = false;
        })
        .catch(() => {
          this.loadingBtn = false;
          Swal.fire({
            icon: "info",
            html: `<h4>${self.$ml.get("unableToCompleteThisRequest")}</h4`,
            showConfirmButton: false,
            timer: 10000,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.inputTags {
  box-shadow: none !important;
  background-color: white;
  input {
    background: rgb(255, 255, 255);
    border-radius: 0;
    box-shadow: none !important;
  }
  input:focus {
  }
  .badge-primary {
    color: #8a0ba9;
    background: #cccccc00;
    padding: 3px 4px;
    font-size: 13px;
    font-weight: 500;
    border: 1px solid #8a0ba9;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 5px;
  }
  .btn {
    display: none;
  }
}

</style>
